import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (header) {
        if (window.scrollY > 50) {
          header.classList.add('bg-white', 'shadow-md');
        } else {
          header.classList.remove('bg-white', 'shadow-md');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sotomago.com';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'ソトマゴ',
    description: '鳥取市で介護保険外サービスを提供するソトマゴは、高齢者向けのパーソナルヘルパーサービスです。介護保険適用外の外出支援、生活支援、通院付き添い、買い物支援、福祉タクシーまで、有資格者がマンツーマンで対応します。',
    image: `${siteUrl}/og-image.jpg`,
    url: siteUrl,
    telephone: '+817090045641',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '新町214',
      addressLocality: '鳥取市',
      addressRegion: '鳥取県',
      postalCode: '680-0035',
      addressCountry: 'JP'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 35.5038,
      longitude: 134.2377
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '09:00',
      closes: '18:00'
    },
    priceRange: '$$',
    areaServed: {
      '@type': 'City',
      name: '鳥取市'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: '介護保険外サービス',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '外出支援サービス',
            description: '通院付き添い、買い物支援、墓参り代行など、介護保険適用外の外出サポート'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '生活支援サービス',
            description: '一人暮らし支援、見守り、家族代行など、個別対応の生活サポート'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '福祉タクシー・介護タクシー',
            description: '有資格者による安全な送迎サービス'
          }
        }
      ]
    }
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="min-h-screen">
        <HeroSection />
        <ProblemsSection />
        <ServicesSection />
        <PricingSection />
        <FAQSection />
        <ContactSection />
      </div>
    </>
  );
}
